import { render } from "./Compound.htm?vue&type=template&id=6c60a418&scoped=true"
import script from "./Compound.js?vue&type=script&lang=js"
export * from "./Compound.js?vue&type=script&lang=js"

import "./Compound.scss?vue&type=style&index=0&id=6c60a418&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c60a418"]])

export default __exports__